// Theme Configuration
export const themes = {
  default: {
    name: 'Default',
    description: 'Clean professional interface',
    cssFile: 'default.css',
    preview: '/previews/default-preview.png'
  },
  cyber: {
    name: 'Cyber',
    description: 'Futuristic network-inspired design',
    cssFile: 'cyber.css',
    preview: '/previews/cyber-preview.png'
  }
};

export const defaultTheme = 'cyber';
